import { Box, Button, Typography, Grid, Link } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { useAcceptHealthAuth } from './hooks/useAcceptHealthAuth';
import { useCallback } from 'react';
import {
  PRIVACY_POLICY_URL,
  TERMS_CONDITIONS_URL,
} from '@xolv-mybrightlink/common';

export const HealthAuthorization = () => {
  const navigate = useNavigate();
  const acceptHealthAuth = useAcceptHealthAuth();

  const onRejected = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        justifyContent: 'space-between',
        mx: { xs: 20, lg: 80 },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          mt: { xs: 12, lg: 25 },
          alignItems: 'start',
        }}
      >
        <Typography
          variant='h5'
          alignSelf={'center'}
          sx={{
            fontWeight: 600,
            mb: 10,
          }}
        >
          <FormattedMessage id='authorization.hiaWelcomeHeader' />
        </Typography>
        <Typography
          paragraph={true}
          sx={{
            mb: 6,
          }}
        >
          <FormattedMessage id='authorization.hiaContent1' />
        </Typography>
        <Typography
          paragraph={true}
          sx={{
            mb: 6,
          }}
        >
          <FormattedMessage id='authorization.hiaContent2' />
        </Typography>
        <Typography
          paragraph={true}
          sx={{
            mb: 6,
          }}
        >
          <FormattedMessage
            id='authorization.hiaContent3'
            values={{
              termsOfUse: (
                <Link
                  rel='noopener'
                  href={TERMS_CONDITIONS_URL}
                  target='_blank'
                  sx={{
                    fontWeight: 500,
                    color: '#307fe2',
                  }}
                >
                  <FormattedMessage id='sidebar.menu.terms-of-use' />
                </Link>
              ),
            }}
          />
        </Typography>
        <Typography
          paragraph={true}
          sx={{
            mb: 6,
          }}
        >
          <FormattedMessage
            id='authorization.hiaContent4'
            values={{
              privacyStatement: (
                <Link
                  rel='noopener'
                  href={PRIVACY_POLICY_URL}
                  target='_blank'
                  sx={{
                    fontWeight: 500,
                    color: '#307fe2',
                  }}
                >
                  <FormattedMessage id='authorization.hiaPrivacyStatement' />
                </Link>
              ),
            }}
          />
        </Typography>
        <Typography
          paragraph={true}
          sx={{
            mb: 6,
          }}
        >
          <FormattedMessage id='authorization.hiaContent5' />
        </Typography>
      </Box>
      <Grid
        justifyContent='center'
        container
        columnSpacing={{ xs: 5, lg: 25 }}
        sx={{
          mb: 10,
        }}
      >
        <Grid item xs={5}>
          <Button
            fullWidth
            variant='outlined'
            size='large'
            data-testid='disagreeHealthAuthButton'
            sx={{
              mt: 6,
              mb: 8,
              borderRadius: 30,
              py: 3.5,
            }}
            onClick={onRejected}
            disableElevation
          >
            <FormattedMessage id='authorization.button.disagree.label' />
          </Button>
        </Grid>
        <Grid item xs={5}>
          <Button
            fullWidth
            variant='contained'
            size='large'
            data-testid='agreeHealthAuthButton'
            sx={{
              mt: 6,
              mb: 8,
              borderRadius: 30,
              py: 3.5,
            }}
            onClick={acceptHealthAuth}
            disableElevation
          >
            <FormattedMessage id='authorization.button.agree.label' />
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};
